import { F1 } from '@client/new/helpers/types';

export type MediaObject = {
  source: string | null;
  cdn01: string;
  image: string | null;
  video: string | null;
  audio: string | null;
  width: number | null;
  height: number | null;
  mimeType: string | null;
};

export type CustomColorSchema = {
  primaryColor: string;
};

export const genders = ['M', 'F'] as const;
export type Gender = (typeof genders)[number];

export const profileModes = ['Live', 'NotLive', 'RunOff'] as const;
export type ProfileMode = (typeof profileModes)[number];

export const sectionIds = ['identity', 'story', 'media', 'discovery'] as const;
export type SectionId = (typeof sectionIds)[number];

export type SectionCompletion = {
  sectionId: SectionId;
  filledFields: number;
  totalFields: number;
  percentage: number;
};

export type ProfileDomain = {
  id: number;
  firstName: string;
  lastName: string;
  customURL: string;
  mode: ProfileMode;
  title: string;
  gender: Gender | null;
  messageProfile: string;
  keywords: string[];
  accomplishments: string;
  profileInstagram: string;
  profileTiktok: string;
  profileYoutubeChannel: string;
  mediaAvatar: MediaObject | null;
  mediaCover: MediaObject | null;
  mediaWelcome: MediaObject | null;
  mediaBanner: MediaObject | null;
  customColorSchema: CustomColorSchema;
};

export type ProfileModelData = {
  profile: ProfileDomain;
};

export type ProfileModelActions = {
  refetch: F1<void, void>;
};

export type ProfileModel = ProfileModelData & ProfileModelActions;
